import { createContext, Dispatch, PropsWithChildren, SetStateAction, useContext, useEffect, useState } from 'react';
import { getAccreditors } from '../data/accreditorRules';
import { IAccreditor } from '../types/IAccreditor';
import { IApiContext } from '../types/Shared';
import { useAuthenticationContext } from './authenticationprovider';
export const AccreditationContext = createContext<IAccreditationProviderContext>({ Pending: true, SetRefreshFlag: () => {} });
export function useAccreditationContext() {
    return useContext(AccreditationContext);
}

export interface IAccreditationProviderContext extends IApiContext<IAccreditor>
{
    SetRefreshFlag: Dispatch<SetStateAction<boolean>>;
}

export function AccreditationProvider({ children }: PropsWithChildren<{}>) {

    const [accreditor, setAccreditor] = useState<IAccreditor>();
    const [error, setError] = useState<string>();
    const [pending, setPending] = useState(true);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const authContext = useAuthenticationContext();

    const getAccreditorResult = async () => {
        try
        {                        
            const currentUserAccreditorCompanyName = authContext.Result?.KeplerAuthStatus.idTokenClaims.companyName;            
            if(currentUserAccreditorCompanyName)
            {       
                const accreditors = await getAccreditors();                
                return accreditors.find(accreditor => accreditor.AccreditorName.toLowerCase() === currentUserAccreditorCompanyName.toLowerCase());                
            }   
            return undefined;   
        }
        catch(err: any) {
            throw err.message || err;
        }  
    };

    useEffect(() => {
        setError(undefined);
        setPending(true);
        getAccreditorResult().then(res => {
            setAccreditor(res);
            setPending(false);
        }).catch(err => {
            setPending(false);
            setError(err);
        })
    }, [authContext.Result, refreshFlag]);
    return (
        <AccreditationContext.Provider value={{ Error: error, Pending: pending, Result: accreditor, SetRefreshFlag: setRefreshFlag }}>
            {children}
        </AccreditationContext.Provider>
    );
}